// extracted by mini-css-extract-plugin
export default {"container":"qHG1XBy fVdHxMU","body":"IA4t6xg","copyright":"p4s35il","links":"zikOExT","pipe":"E1LOrCT","hideOnSmallViewport":"RgP909u"};